import { h, Fragment as F } from 'preact'
import { useEffect, useState, useMemo } from 'preact/hooks';
import { createPortal } from 'preact/compat';


const options2 = { style: 'currency', currency: 'USD' };
const numberFormat2 = new Intl.NumberFormat('en-US', options2);

export function SearchResultPremium({data, similar_sales, domain}) {
  const [ currentPageNo, updatePageNo ] = useState(1);
  const [ haveMore, updateStatus ] = useState(false)


  const domainMessage = document.getElementById('domainMessage');

  const HeaderInfo = () => {
    return (
      <F>
        <h1 class="font-semibold text-center" ><p class="text-brandColor inline">{domain}</p> is a premium domain</h1>
        <img src="/assets/prem.png" class="mx-auto top-[30px] sm:top-[50px] relative w-1/2 sm:w-auto"/>
        <div class="relative top-[-30px]">
          <p class="text-center relative leading-7 sm:leading-9">One time registration fee.<br/>All premiums renews at normal renewal rates.<br/>Prices are subject to changes without notice.</p>
          <div class="flex justify-center">
            <a class="bg-brandColor flex items-center justify-between  pl-7 pr-5 py-4 mt-5 text-white rounded-[100px] md:h-[66px] w-[244px]" href={`/getdomain/${domain}/prem`}>
              <div>Make an offer</div>
              <svg width="18" height="18" viewBox="0 0 18 18"  fill="#fff" class="" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.16971 0.372264C1.67336 -0.124087 0.868614 -0.124088 0.372263 0.372263C-0.124088 0.868614 -0.124087 1.67336 0.372264 2.16971L7.20255 9L0.372263 15.8303C-0.124088 16.3266 -0.124088 17.1314 0.372263 17.6277C0.868614 18.1241 1.67336 18.1241 2.16971 17.6277L9.89872 9.89872C10.3951 9.40237 10.3951 8.59763 9.89872 8.10128L2.16971 0.372264Z" />
              </svg>
            </a>
          </div>
        </div>
      </F>
    )
  }

  return (
    <section class="relative mx-auto px-[30px] mb-12 container">
      {createPortal(<HeaderInfo />, domainMessage)}
      <h3 class="text-[1.42rem] leading-6 mb-6 font-playfair text-default font-semibold">What is a premium domain?</h3>
      <div class="flex md:flex-row flex-col gap-4 md:gap-12">
        <p>Premium domains are website names that are likely to attract significant online traffic because they contain key search terms, industry-specific words or generic words - hence their premium status and pricing.</p>
        <p>Buying a premium domain is an opportunity to invest in valuable online real estate that you can use for your current business, or for a business you plan to open in the future.</p>
      </div>
      <h3 class="text-[1.42rem] leading-6 mb-6 mt-12 font-playfair text-brandColor4 text-center font-semibold">Similar historical sales</h3>
      <div class='grid md:grid-cols-2 gap-4'>
        {
          similar_sales?.slice(0,4).map((sale) => {
            return (
                <div class="inline-flex items-center border border-gray3 bg-white rounded-full px-7 py-5 rounded-[100px] relative justify-between" key={`${sale.domainname}-${sale.year}-${sale.price}`}>
                  <div>{sale.domainname}</div>
                  <div class="font-semibold">{numberFormat2.format(sale.price)}</div>
                </div>
            )
          })
        }
      </div>

    </section>
  )
}